import React from "react"
import Button from "../common/Button"
import { FaTimes, FaEdit, FaTrash } from "react-icons/fa"

const DatosJerarquicos = ({
    data,
    eliminar,
    eliminarDetalle,
    editar,
    editarPadre = [{}],
    registrar,
    campoTitulo,
    campoDetalles,
    campoNombre,
    campoDetalle = "",
    nombreTitulo = "",
    nombreDetalle = ""
}) => {
    return (
        <div className="py-1 px-5 font-sans">
            {data.map((item) => (
                <div key={item["id"]} className="mb-4 border border-gray-300 rounded-lg shadow-md p-4">
                    {/* Título */}
                    <div className="flex gap-3 items-center justify-between mb-4">
                        <div className="flex gap-2 items-center">
                            <h1 className="text-2xl font-bold text-gray-800">{item[campoTitulo]}</h1>
                            {(nombreTitulo == "Cuota") && <h1 className="text-base font-medium text-white bg-orange-500 px-2 py-1 rounded shadow-sm">
                                Cuotas: {item.cuotas}
                            </h1>
                            }

                        </div>
                        <div className="flex gap-2">

                            {!(nombreTitulo == "Cuota") && <Button type="save" texto="&#10010;" onClick={() => registrar(item["id"])} />}

                            <Button
                                type="update"
                                texto={<FaEdit />}
                                onClick={() => editarPadre({ id: item["id"], descripcion: item[campoTitulo] })}
                            />
                            <Button
                                type="delete"
                                texto={<FaTrash className="text-white" />}
                                onClick={() => eliminar(item["id"])}
                            />
                        </div>
                    </div>

                    {/* Tabla de detalles */}
                    {item[campoDetalles] && (
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left border border-gray-200 rounded-lg">
                                <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
                                    <tr>
                                        <th className="py-2 px-4 w-12">Acciones</th>
                                        <th className="py-2 px-4">{nombreTitulo || "Nombre"}</th>
                                        <th className="py-2 px-4">{nombreDetalle || ""}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item[campoDetalles].map((detalle) => (
                                        <tr key={detalle["id"]} className="border-b hover:bg-gray-50">
                                            <td className="py-2 px-4 flex gap-2">
                                                {!(nombreTitulo == "Cuota") && <Button
                                                    type="delete"
                                                    texto={<FaTimes />}
                                                    onClick={() => eliminarDetalle(detalle["id"])}
                                                />}
                                                <Button
                                                    type="update"
                                                    texto={<FaEdit className="text-blue-500" />}
                                                    onClick={() =>
                                                        editar({
                                                            id: detalle["id"],
                                                            nombre: detalle[campoNombre],
                                                            detalle: detalle[campoDetalle],
                                                        })
                                                    }
                                                />
                                            </td>
                                            <td className="py-2 px-4">{detalle[campoNombre]}</td>
                                            <td className="py-2 px-4 text-gray-600">{detalle[campoDetalle]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

export default DatosJerarquicos

